import { Page } from './Page';
import { isoDate } from '../lib/dates';
import { MessagesView } from '../components/messages/MessagesView';
import { useNav } from './NavContext';

// Messages — copy-paste staff/customer messages. The selected day is the app's
// shared anchor (top-bar date picker); the rail + message live in MessagesView.
// First topic: Dogs Leaving.
export function MessagesPage() {
  const { anchor } = useNav();

  return (
    <Page title="Messages">
      <MessagesView anchor={isoDate(anchor)} />
    </Page>
  );
}
